"use client"

import { ArrowBigUpDash } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowBigUpDashIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowBigUpDashIcon = component(Icon)({ as: ArrowBigUpDash })
